import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import AddIcon from '@mui/icons-material/Add';

const NewDoc = ({ currentUser, socket }) => {

    const [show, setShow] = useState(false);

    const handleClose = () => {
        setShow(false);
    }

    const [file, setFile] = useState(null);

    const handleFile = e => {
        setFile(e.target.files[0]);
    }

    const handleSubmit = () => {
        // file type is only image.
        if (file.size < 16000000) {
            let payload = {
                id: currentUser.user._id,
                jwt: localStorage.getItem('auth_token'),
                fileName: file.name,
                file,
                ip: localStorage.getItem('ip')
            }
            socket.emit('new doc', payload);
            setShow(false);
        } else {
            console.warn("You can only upload images.");
        }
    };

    return (
        <>
            {(currentUser.isAuthenticated && currentUser.user.isAdmin > 8 && currentUser.adminSettings) && (
                <Box sx={{ display: 'flex', justifyContent: 'center', my: 2 }}>
                    <Card>
                        <CardActionArea onClick={() => setShow(true)} sx={{ p: 3 }}>
                            <AddIcon sx={{ fontSize: 60 }} />
                        </CardActionArea>
                    </Card>
                </Box>
            )}
            <Dialog open={show} onClose={handleClose} fullWidth maxWidth="sm">
                <DialogTitle>New Document</DialogTitle>
                <DialogContent>
                    <Button variant="outlined" component="label" sx={{ mt: 1 }}>
                        Choose File
                        <input type="file" hidden onChange={handleFile} />
                    </Button>
                    {file && <Box sx={{ mt: 1 }}>{file.name}</Box>}
                </DialogContent>
                <DialogActions>
                    <Button variant="outlined" onClick={handleClose}>
                        Close
                    </Button>
                    <Button variant="contained" onClick={handleSubmit}>
                        Upload
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
};

export default NewDoc;
